import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import OperatorInfoEdit from "./OperatorInfoEdit";

class OperatorInfo extends React.Component {
    static propTypes = {
        info: PropTypes.object.isRequired,
        onInfoChange: PropTypes.func.isRequired,
    };

    render() {
        const {info, onInfoChange, className} = this.props;

        const operatorInfo = Object.entries(info);

        let classes = "card-promo card-promo--preview ";
        if (className) {
            classes += className;
        }

        return (
            <div className={classes}>
                <div className="card-body">
                    <p className="card-text mb-1">
                        <FormattedMessage id="conversation.operator_info" defaultMessage="What operator said about himself in this conversation?" />
                    </p>
                    <p className="card-text card-list text-dark font-weight-semi mb-1">
                        {operatorInfo.map(item => (
                            <span key={'operator-info-' + item[0]}>{item[0]}: {item[1]}</span>
                        ))}
                    </p>
                    <OperatorInfoEdit info={info} onInfoChange={onInfoChange}/>
                </div>
            </div>
        )
    }
}

export default OperatorInfo;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/OperatorInfo/OperatorInfo.jsx